import * as Yup from 'yup';

// const phoneNumberRegex = /^\+44[\s-]?(?:7\d{3}[\s-]?\d{6}|\d{2,4}[\s-]?\d{3,4}[\s-]?\d{3,4})$/;
const urlRegex = /^(https?:\/\/)?(www\.)?([a-zA-Z0-9-]+(\.[a-zA-Z]{2,})+)(\/[^\s]*)?$/;

const businessInfoSchema = Yup.object().shape({
    businessName: Yup.string().required().max(100),
    businessContact: Yup.string()
        .required(),
        // .test(
        //     'min-length',
        //     'Phone number must be at least 8 digits', // Adjust the minimum length message as needed
        //     (value) => !value || value.length >= 8 // Allows empty strings or checks for minimum length if entered
        // )
        // .max(20, 'Phone Number should not exceed 20 digits')
        // .test(
        //     'is-valid-phone',
        //     // 'Phone number must contain only numbers',
        //     (value) => !value || phoneNumberRegex.test(value) // Allows empty strings or matches the regex
        // ),
    website: Yup.string()
        .nullable()
        .test('url-validation', 'Please enter a valid website URL', function (value) {
            // If the value is empty, return true (no validation)
            if (!value) return true;
            return urlRegex.test(value); // Return true if valid, false otherwise
        }),
    businessLocation: Yup.string().required(),
    aboutBusiness: Yup.string().required().max(1000)
})

export { businessInfoSchema }